<template>
    <div>
        <button class="button is-outlined is-info table-button" @click="openModal">{{ $t('modules.evaluations.reportRegen.modalButtonLabel') }}</button>
        <Modal @onConfirm="onConfirm"
            @onClose="onClose"
            :isOpen="isOpen"
            :modalTitle="$t('modules.evaluations.reportRegen.modalTitle')"
            :confirmLabel="$t('modules.evaluations.reportRegen.modalConfirmLabel')" >

            <div class="regen_report_language_select">
                <label>{{ $t('modules.evaluations.reportRegen.chooseRecruiterReportsLocale') }}</label>
                <div class="select refs_select">
                    <select v-model="recruiterLanguage">
                        <option v-for="(lang, i) in recruiterlocales" :key="`Lang${i}`" :value="lang" >
                            {{ $t(localeTradId(lang)) }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="regen_report_language_select">
                <label>{{ $t('modules.evaluations.reportRegen.chooseCandidateReportsLocale') }}</label>
                <div class="select refs_select">
                    <select v-model="candidateLanguage">
                        <option v-for="(lang, i) in candidatelocales" :key="`Lang${i}`" :value="lang" >
                            {{ $t(localeTradId(lang)) }}
                        </option>
                    </select>
                </div>
            </div>

        </Modal>
    </div>
</template>

<script>

export default {
    name: 'ReportRegenModal',
    props: ['evaluation', 'index'],
    components: {

    },
    data(){
        return {
            isOpen: false,
            candidateLanguage: null,
            recruiterLanguage: null,
            candidatelocales: ['fr', 'en'],
            recruiterlocales: ['fr', 'en'],
        }
    },
    computed: {},
    methods: {
        openModal(){
            this.isOpen = true
        },
        onConfirm(){
            this.$store.dispatch('EvalStore/regenReports', {id: this.evaluation.id, user_language: this.recruiterLanguage, candidate_language: this.candidateLanguage})
            this.isOpen = false
        },
        localeTradId(lang){
            return 'layouts.locales.' + lang
        },
        onClose(){
            this.isOpen = false
        }
    }
}
</script>

<style lang="scss" scoped>
    .refs_select{
        width: 100%;
        select{
            width: 100%;
        }
    }
    .regen_report_language_select{
        padding-bottom: 30px;
    }

</style>